module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAASxJREFUWEftlt0NgjAUhekmMImwiSwBvKlvwBLiJmxiJ6GeEjDYXrS2oX2AJiZiqPfrOfenLAq8WOD40QHgrEBVVbEQ4g4rY2knYyyv67o3tdYZoCxLoQTj/0A4ARRFcUGwK3Harmma3EQFJwCcXkp/JgJxACQ+AJ6z96oNvgBU/98cADBS1+glSsov/svXt7VgKj0p/9raLgl/nJwC4vixR7Xc0B/k94+lWTAFiLHhIRsKTpsOw3DCc4qd8mO7yP6gASwayygjntcy3Qakx39my40mAKuZbkGgJefuAIJboJWnVwumKdkFS0IAZOpdwbcCidqMvAJQA8onADkf9gNAJaCsBl8KaA1oLkUKYB4+o2cW43dZ5hxX9q5t29va3LC+EVkMInLLARBcgRc/k9Ihnpc+agAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/noZan.png
// module id = fz05
// module chunks = 110